import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../images/new_founder_header.png';
var _hoisted_1 = {
  class: "founder_box"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "founder_left"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "header_img"
})], -1);

var _hoisted_3 = {
  class: "founder_right"
};

var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "right_title"
}, "CEO寄语", -1);

var _hoisted_5 = {
  class: "more_founder",
  ref: "content"
};
var _hoisted_6 = ["innerHTML"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_collapse_item = _resolveComponent("el-collapse-item");

  var _component_el_collapse = _resolveComponent("el-collapse");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createVNode(_component_el_collapse, {
    accordion: true,
    modelValue: $setup.activeNames,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return $setup.activeNames = $event;
    })
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createVNode(_component_el_collapse_item, {
        title: "Consistency",
        class: "founder_collapse",
        name: _ctx.index
      }, {
        title: _withCtx(function () {
          return [_createElementVNode("span", {
            class: _normalizeClass(['right_intro', !$setup.showMoreFund ? 'content_coll_title_fun' : 'title_none_fun'])
          }, "神经精神系统疾病是全球共同面对的重大社会挑战，随着人口持续老龄化和社会压力增加，患病率逐年提升，治疗需求持续增高。神经精神疾病在生理和心理上双重挑战，给患者及其家庭带来了巨大的负担。元羿生物将秉承患者为先的初衷，汇聚全球范围内的专业实力和创新资源，基于团队长期专注获得的对于疾病和生物学的深刻理解， 积极驱动前沿科学转化，坚持高效而创新的临床开发，致力于为中国及全球患者提供突破性的疾病解决方案。", 2), _createElementVNode("div", {
            class: _normalizeClass(['intro_more_founder', !$setup.showMoreFund ? 'opacity_show' : 'opacity_none_founder']),
            onClick: _cache[0] || (_cache[0] = function () {
              return $setup.toggleMore && $setup.toggleMore.apply($setup, arguments);
            })
          }, null, 2)];
        }),
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
            class: "more_intro",
            innerHTML: $setup.companyInfo.founderMessage
          }, null, 8, _hoisted_6), _createElementVNode("div", {
            class: "intro_more_close intro_close",
            onClick: _cache[1] || (_cache[1] = function () {
              return $setup.retract && $setup.retract.apply($setup, arguments);
            })
          })], 512)];
        }),
        _: 1
      }, 8, ["name"])])];
    }),
    _: 1
  }, 8, ["modelValue"])]);
}